export const categories = [
  {
    id: 1,
    slug: "cross-border-business",
    name: "跨境商务",
    description: "提供全球跨境贸易、国际物流、海外仓储等一站式商务解决方案",
    icon: "ri-global-line",
    articleCount: 28,
  },
  {
    id: 2,
    slug: "international-investment",
    name: "国际投资",
    description: "海外资产配置、国际项目投资、全球市场分析等专业投资服务",
    icon: "ri-funds-line",
    articleCount: 35,
  },
  {
    id: 3,
    slug: "cultural-exchange",
    name: "文化交流",
    description: "国际教育、语言培训、文化交流活动等跨文化服务项目",
    icon: "ri-earth-line",
    articleCount: 22,
  },
  {
    id: 4,
    slug: "travel-immigration",
    name: "出行移民",
    description: "签证办理、海外置业、移民咨询等全方位出行与定居服务",
    icon: "ri-plane-line",
    articleCount: 30,
  },
  {
    id: 5,
    slug: "legal-finance",
    name: "法律金融",
    description: "国际法律咨询、跨境税务规划、海外金融账户管理等专业服务",
    icon: "ri-scales-line",
    articleCount: 18,
  },
  {
    id: 6,
    slug: "technology-innovation",
    name: "科技创新",
    description: "国际技术转移、海外专利申请、全球科技合作等创新服务",
    icon: "ri-lightbulb-line",
    articleCount: 15,
  },
];

export const features = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "采用国际领先的加密技术与多重安全防护体系，确保您的数据与交易安全无忧，通过多项国际安全认证。",
  },
  {
    id: 2,
    icon: "ri-flashlight-line",
    title: "极速响应",
    description: "全球服务器节点部署，智能路由优化，平均响应时间低于100毫秒，随时随地享受流畅服务体验。",
  },
  {
    id: 3,
    icon: "ri-global-line",
    title: "全球覆盖",
    description: "服务网络覆盖全球200多个国家和地区，支持多语言、多币种，真正实现无国界一站式服务。",
  },
  {
    id: 4,
    icon: "ri-customer-service-2-line",
    title: "专业服务",
    description: "拥有资深国际化服务团队，7×24小时全天候客服支持，为您提供专业、贴心的个性化服务方案。",
  },
];

export const stats = [
  { id: 1, value: "500万+", label: "全球用户" },
  { id: 2, value: "200+", label: "覆盖国家" },
  { id: 3, value: "50+", label: "服务项目" },
  { id: 4, value: "28年", label: "行业经验" },
];

export const articles = [
  {
    id: 1,
    categoryId: 1,
    categoryName: "跨境商务",
    title: "2026年全球跨境贸易新趋势：数字化转型与区域合作",
    excerpt: "随着全球经济格局的持续演变，跨境贸易领域正迎来前所未有的数字化转型浪潮。本文深入分析2026年全球跨境贸易的五大新趋势，帮助企业把握变革机遇。",
    content: `在全球经济深度融合的今天，跨境贸易正经历着深刻的变革。2026年，数字化转型与区域经济合作成为推动跨境贸易发展的两大核心动力。

首先，数字技术的广泛应用正在重塑传统贸易模式。区块链技术在跨境支付与供应链金融中的应用日益成熟，大幅提升了交易效率与透明度。据国际商会数据，采用区块链技术的跨境贸易结算时间平均缩短了60%以上。

其次，人工智能驱动的智能报关系统在全球主要贸易口岸得到推广，不仅减少了人工审核时间，更将报关差错率降至历史最低水平。

第三，RCEP等区域贸易协定的深入实施，为亚太地区企业创造了更加便利的贸易环境。关税减免、原产地规则简化等措施持续释放红利。

第四，绿色贸易成为跨境商务的新标配。碳关税机制的推进促使出口企业加快绿色转型，ESG合规成为参与国际竞争的基础门槛。

第五，跨境电商独立站模式崛起，越来越多的企业选择通过自建渠道直接触达海外消费者，品牌化、本土化战略成为制胜关键。

至成国际深耕跨境商务领域二十余年，为您提供从市场调研、合规咨询到物流配送的全链路服务支持，助力企业高效拓展全球市场。`,
    author: "王明远",
    publishDate: "2026-08-01",
    readCount: 12580,
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20modern%20office%20environment%20with%20warm%20lighting%20and%20clean%20minimal%20design%2C%20business%20atmosphere%2C%20soft%20neutral%20tones%2C%20editorial%20photography%20style&width=400&height=280&seq=article-cb-01&orientation=landscape",
  },
  {
    id: 2,
    categoryId: 2,
    categoryName: "国际投资",
    title: "海外资产配置新篇章：2026下半年投资策略全解析",
    excerpt: "在全球利率环境变化与地缘政治格局调整的背景下，海外资产配置策略需要重新审视。本文为您详细解读2026下半年的投资方向与避险策略。",
    content: `2026年全球投资环境呈现出复杂多变的特征。在美联储货币政策转向、欧洲经济温和复苏以及亚太新兴市场持续增长的多元格局下，海外资产配置策略需要更加精细化。

从资产类别来看，全球债券市场在利率趋稳后重新获得配置价值。特别是亚洲高评级企业债与绿色债券，凭借较高的票息收益与政策支持，成为稳健型投资者的优选。

股票市场方面，科技创新与消费升级依然是长期投资主线。人工智能产业链、新能源技术以及医疗健康领域的龙头企业展现出强劲的增长韧性。新兴市场中，东南亚与中东地区的消费升级与基础设施建设带来结构性投资机会。

另类投资领域，私募股权与风险投资持续活跃。科技初创企业估值回归理性后，优质标的的投资性价比显著提升。同时，数字货币与代币化资产在监管框架逐步完善后，开始吸引更多机构投资者的关注。

风险管理方面，地缘政治风险、汇率波动以及合规监管变化是需要重点关注的因素。建议投资者采用多元化的资产配置策略，通过跨区域、跨资产类别的组合分散风险。

至成国际投资顾问团队持续跟踪全球市场动态，为您提供个性化的海外投资方案，助您在全球资产配置中把握先机、稳健前行。`,
    author: "陈志远",
    publishDate: "2026-07-28",
    readCount: 9870,
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20financial%20district%20skyline%20with%20glass%20buildings%20and%20warm%20sunset%20light%2C%20professional%20investment%20atmosphere%2C%20clean%20corporate%20aesthetic%2C%20editorial%20photography&width=400&height=280&seq=article-ii-01&orientation=landscape",
  },
  {
    id: 3,
    categoryId: 3,
    categoryName: "文化交流",
    title: "国际教育新风向：2026年全球留学趋势与机遇",
    excerpt: "后疫情时代的国际教育格局正经历深刻调整，新兴留学目的地的崛起与在线教育的普及为学子们带来更多选择。",
    content: `2026年，国际教育领域呈现出多元化与个性化的显著特征。传统的英美澳加留学目的地依然保持吸引力，但更多新兴留学目的地正在崛起。

亚洲方面，新加坡、日本和韩国凭借优质的教育资源、相对较低的留学成本以及良好的就业前景，吸引了大量国际学生。特别是新加坡的双语教育环境和国际化视野，使其成为亚洲留学首选地之一。

欧洲方面，德国、荷兰、瑞士等国的公立大学以高性价比著称。德国大部分州仍对国际学生实行免学费政策，再加上其强大的工业基础和就业市场，工科与商科专业备受青睐。

值得注意的是，"微留学"和短期交换项目在2026年迎来爆发式增长。越来越多的学生选择通过2-6个月的短期项目体验海外学习生活，既降低了时间与金钱成本，又获得了宝贵的国际视野。

在线国际教育的普及也为更多学子打开了通往世界的大门。世界顶尖大学的在线学位与证书课程认可度持续提升，跨国企业雇主对在线学历的接受度已达到历史新高。

至成国际教育咨询团队拥有丰富的海外院校资源与专业的申请经验，为每一位学子量身定制最适合的留学规划方案。`,
    author: "林诗涵",
    publishDate: "2026-07-25",
    readCount: 15600,
    imageUrl: "https://readdy.ai/api/search-image?query=Diverse%20international%20students%20studying%20together%20in%20modern%20university%20library%2C%20warm%20natural%20light%2C%20multicultural%20atmosphere%2C%20clean%20academic%20environment%2C%20editorial%20style&width=400&height=280&seq=article-ce-01&orientation=landscape",
  },
  {
    id: 4,
    categoryId: 4,
    categoryName: "出行移民",
    title: "2026全球移民政策盘点：哪些国家更适合您",
    excerpt: "全球移民政策持续收紧的背景下，精准把握各国政策动向至关重要。本文为您梳理2026年最值得关注的热门移民项目。",
    content: `2026年全球移民政策总体呈现"质量优先、精准引进"的趋势。各国纷纷调整移民政策，更加注重申请人的综合素质与经济贡献能力。

投资移民项目中，葡萄牙黄金签证在经历改革后仍保持较高热度，基金投资路径成为主流选择。希腊购房移民门槛上调至50万欧元后，申请量虽有所回落，但核心区域的房产投资价值依然突出。

技术移民方面，加拿大继续维持较高的移民配额，快速通道（Express Entry）的最低邀请分数在2026年上半年呈下降趋势，为更多技术人才提供了机会。澳大利亚技术移民配额稳中有升，特别是医疗健康、信息技术和工程领域的紧缺职业获得优先审理。

创业移民成为2026年的一大亮点。英国创新创始人签证、新加坡创业准证以及阿联酋黄金签证等项目，吸引了大量有创新能力和商业背景的申请人。

数字游民签证在全球范围内加速普及。截至2026年中，已有超过50个国家和地区推出了针对远程工作者的特殊签证政策，为自由职业者和跨国远程工作者提供了合法居留的便利通道。

至成国际移民顾问团队密切跟踪全球移民政策变化，为您提供从资格评估、方案定制到落地安家的全流程专业服务。`,
    author: "张锦程",
    publishDate: "2026-07-20",
    readCount: 21300,
    imageUrl: "https://readdy.ai/api/search-image?query=Luxurious%20modern%20residential%20area%20with%20green%20landscape%20and%20contemporary%20architecture%2C%20warm%20sunlight%2C%20peaceful%20living%20environment%2C%20clean%20minimal%20design%2C%20editorial%20photography%20style&width=400&height=280&seq=article-ti-01&orientation=landscape",
  },
  {
    id: 5,
    categoryId: 5,
    categoryName: "法律金融",
    title: "跨境税务合规新规解读：企业如何应对全球税收透明化",
    excerpt: "全球税收透明化进程加速，跨境企业与高净值个人面临的税务合规要求日趋严格。本文解读最新政策变化与应对策略。",
    content: `随着OECD推动的全球税收透明化框架的深入实施，2026年跨境税务合规环境发生了显著变化。全球最低企业税率（15%）已在主要经济体落地执行，对跨国企业的税务筹划产生深远影响。

CRS（共同申报准则）的覆盖范围持续扩大，参与辖区已超过120个。金融机构的信息申报要求更加细致，高净值个人与跨境企业的金融账户信息透明度显著提升。

数字经济税收规则的变革是2026年的另一大看点。多个国家已开征数字服务税或类似税种，互联网企业与数字平台面临新的税务合规挑战。跨国科技企业的利润分配与税基确定规则正在被重新定义。

企业应对策略方面，建议从以下几个方面着手：第一，全面梳理跨境业务架构，确保转让定价文档的合规性；第二，建立内部税务风险管理体系，定期开展税务健康检查；第三，关注税收协定网络的变化，合理利用双边协定的优惠条款；第四，加强与专业税务顾问的合作，及时应对政策变化。

对于高净值个人而言，身份规划与税务居民身份的合理安排至关重要。建议在专业顾问的指导下，综合考量家庭成员的教育、生活需求与资产配置目标，制定长期稳健的税务规划方案。

至成国际法律金融团队汇聚了资深税务律师、注册会计师与跨境规划专家，为您提供全面的税务合规与财富管理服务。`,
    author: "赵宏宇",
    publishDate: "2026-07-15",
    readCount: 8450,
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20legal%20office%20with%20law%20books%20and%20elegant%20wooden%20furniture%2C%20warm%20ambient%20lighting%2C%20sophisticated%20corporate%20atmosphere%2C%20clean%20minimal%20design%2C%20editorial%20style&width=400&height=280&seq=article-lf-01&orientation=landscape",
  },
  {
    id: 6,
    categoryId: 6,
    categoryName: "科技创新",
    title: "全球AI产业格局洞察：从技术突破到商业落地",
    excerpt: "人工智能技术正从实验室加速走向产业应用，全球AI产业格局在2026年呈现出新的竞争态势与合作模式。",
    content: `2026年，人工智能产业进入了从"技术炫技"到"价值创造"的关键转折期。大语言模型的竞争趋于白热化，但真正的商业价值正在从模型层向应用层转移。

产业应用方面，AI在医疗健康领域的突破最为显著。AI辅助药物研发将新药发现周期从传统的5-7年缩短至18-24个月，多款AI参与研发的创新药物在2026年获得监管批准。在医学影像诊断领域，AI系统的准确率已达到甚至超越资深医师水平。

制造业的智能化转型加速推进。工业AI质检系统的普及率在2026年突破40%，数字孪生技术在航空航天与汽车制造中的应用日趋成熟。预测性维护系统帮助企业将设备停机时间平均减少了35%。

金融科技领域，AI驱动的智能投顾、风险管理和反欺诈系统已成为行业标配。生成式AI在个性化金融产品设计与客户服务中的应用，大幅提升了用户体验与运营效率。

全球AI治理框架也在2026年取得重要进展。主要经济体纷纷出台AI监管法规，在促进创新与防范风险之间寻求平衡。跨境数据流动规则、AI伦理准则以及算法透明度要求成为国际对话的焦点议题。

至成国际科技创新团队持续关注全球AI发展动态，为企业和投资者提供前沿的技术洞察与商业机会分析。`,
    author: "孙浩然",
    publishDate: "2026-07-10",
    readCount: 18900,
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20technology%20innovation%20lab%20with%20holographic%20displays%20and%20sleek%20modern%20equipment%2C%20warm%20ambient%20lighting%2C%20clean%20minimal%20design%2C%20professional%20atmosphere%2C%20editorial%20photography&width=400&height=280&seq=article-ti-02&orientation=landscape",
  },
];

export const aboutContent = {
  brand: {
    title: "品牌故事",
    sections: [
      {
        title: "始于1996，放眼全球",
        content: "1996至成国际成立于1996年，总部设在香港，是一家拥有二十八年国际化服务经验的综合性平台。从最初专注于跨境贸易咨询的小型机构，逐步发展成为涵盖商务、投资、教育、移民、法律、科技等多领域的国际化服务集团。",
      },
      {
        title: "使命与愿景",
        content: "我们的使命是「连接世界，成就未来」——通过专业、高效、安全的国际化服务，帮助个人与企业在全球化进程中抓住机遇、应对挑战。我们的愿景是成为全球最受信赖的国际化服务平台，让每一位用户都能轻松触达世界。",
      },
      {
        title: "核心价值观",
        content: "诚信为本、专业至上、创新驱动、全球视野——这四个核心价值观贯穿至成国际的每一项服务。我们相信，只有坚持诚信经营、保持专业水准、持续创新突破、拓展全球视野，才能为客户创造真正的价值。",
      },
    ],
  },
  reputation: {
    title: "行业信誉",
    sections: [
      {
        title: "资质认证",
        content: "至成国际持有多个国家与地区的专业服务资质，包括香港公司注册处颁发的信托或公司服务提供者牌照（TCSP）、国际投资顾问牌照以及多项ISO管理体系认证。我们的专业团队由持牌律师、注册会计师、资深投资顾问及行业专家组成。",
      },
      {
        title: "行业荣誉",
        content: "凭借卓越的服务品质，至成国际连续多年荣获「亚洲最佳国际化服务平台」「最具影响力跨境服务品牌」等行业殊荣。2025年更获评「福布斯亚洲值得关注企业200强」，充分体现了业界对我们的高度认可。",
      },
      {
        title: "用户口碑",
        content: "超过500万全球用户的信赖之选，客户满意度连续五年保持在98%以上。我们的客户遍布全球200多个国家和地区，涵盖跨国企业、中小企业、高净值个人以及普通家庭用户。每一份信赖都是我们前进的动力。",
      },
    ],
  },
  contact: {
    title: "联系方式",
    address: "香港中环皇后大道中99号中环中心58楼",
    phone: "+852 2888 8888",
    email: "contact@1996zhcheng.com",
    hours: "周一至周五 9:00-18:00（香港时间）",
    wechat: "zhcheng1996",
    locations: [
      { city: "香港", address: "中环皇后大道中99号中环中心58楼" },
      { city: "上海", address: "浦东新区陆家嘴金融贸易区世纪大道100号" },
      { city: "新加坡", address: "1 Raffles Place, #20-61, One Raffles Place" },
      { city: "伦敦", address: "30 St Mary Axe, London, EC3A 8BF" },
    ],
  },
};